import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AuthGuard } from '~/core/classes/auth/auth.guard';
import { BuSelectionGuard } from '~/core/classes/auth/bu-selection.guard';
import { PendingChangesGuard } from '~/core/classes/auth/pending-changes.guard';

//******************************************************************************
//  App Pages
//******************************************************************************
import { HomeComponent } from '~/pages/home/home.component';
import { BuSelectionComponent } from '~/pages/bu-selection/bu-selection.component';
import { ApprovalFlowComponent } from '~/pages/approval-flow/approval-flow.component';
import { WellDetailComponent } from '~/pages/well-detail/well-detail.component';
import { WellPrepareComponent } from '~/pages/well-prepare/well-prepare-component';
import { BulkUploadComponent } from '~/components/bulk-upload/bulk-upload.component';

export const routes: any[] = [
    {
        path: '',
        title: 'Wells Home',
        isNav: false,
        component: BuSelectionComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'wells',
        title: 'Wells',
        icon: 'oil_barrel',
        imageIcon: '/assets/oil-rig.png',
        isNav: true,
        component: HomeComponent,
        canActivate: [AuthGuard, BuSelectionGuard]
    },
    {
        path: 'wells/:wellName',
        title: 'Well Detail',
        isNav: false,
        component: WellDetailComponent,
        canActivate: [AuthGuard, BuSelectionGuard]
    },
    {
        path: 'wells/:wellName/review',
        title: 'Review Changes',
        isNav: false,
        component: WellDetailComponent,
        canActivate: [AuthGuard, BuSelectionGuard],
        canDeactivate: [PendingChangesGuard],
        data: { showReview: true }
    },
    {
        path: 'wells/:wellName/review/approve',
        title: 'Approval Flow',
        isNav: false,
        component: ApprovalFlowComponent,
        canActivate: [AuthGuard, BuSelectionGuard],
        canDeactivate: [PendingChangesGuard]
    },
    {
        path: 'wells/:wellName/prepare',
        title: 'Prepare Well',
        isNav: false,
        component: WellPrepareComponent,
        canActivate: [AuthGuard, BuSelectionGuard]
    },
    {
        path: 'upload',
        title: 'Upload',
        isNav: false,
        component: BulkUploadComponent,
        canActivate: [AuthGuard, BuSelectionGuard]
    },
   
    {
        path: '**',
        redirectTo: 'notfound',
        pathMatch: 'full'
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [
        RouterModule
    ]
})

export class AppRouting { }
